// frontend/src/pages/admin/FreelancerBids.jsx
// Freelancer Bid Management Component

import React, { useState, useEffect } from 'react';
import api from '../../utils/api';

const FreelancerBids = () => {
  const [bids, setBids] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [showImportModal, setShowImportModal] = useState(false);
  const [projectId, setProjectId] = useState('');
  const [selectedBid, setSelectedBid] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);

    const [showBidModal, setShowBidModal] = useState(false);
    const [bidProject, setBidProject] = useState(null);

    const [bidAmount, setBidAmount] = useState('');
    const [bidProposal, setBidProposal] = useState('');
    const [bidDays, setBidDays] = useState('');

  useEffect(() => {
    fetchBids();
  }, [statusFilter]);

  const fetchBids = async () => {
    try {
      setLoading(true);
      const params = {};
      if (statusFilter) params.status = statusFilter;
      if (searchTerm) params.search = searchTerm;
      
      const response = await api.get('/freelancer', { params });
      setBids(response.data.data);
    } catch (error) {
      console.error('Fetch bids error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleImport = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/freelancer/import', { projectId });
      alert('Project imported successfully!');
      setShowImportModal(false);
      setProjectId('');
      fetchBids();
    } catch (error) {
      alert(error.response?.data?.message || 'Import failed');
    }
  };

  const handleSync = async (id) => {
    try {
      await api.put(`/freelancer/${id}/sync`);
      alert('Project synced successfully!');
      fetchBids();
    } catch (error) {
      alert('Sync failed');
    }
  };

  const handleUpdateStatus = async (id, status) => {
    try {
      await api.put(`/freelancer/${id}`, { status });
      alert('Status updated successfully!');
      fetchBids();
    } catch (error) {
      alert('Update failed');
    }
  };

  const viewDetails = async (bid) => {
    try {
      const response = await api.get(`/freelancer/${bid._id}`);
      setSelectedBid(response.data.data);
      setShowDetailsModal(true);
    } catch (error) {
      alert('Failed to load details');
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      active: 'bg-blue-100 text-blue-800',
      awarded: 'bg-green-100 text-green-800',
      closed: 'bg-gray-100 text-gray-800',
      cancelled: 'bg-red-100 text-red-800'
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
  };

    const handlePlaceBid = async () => {
        try {
            //await api.post(`/freelancer/${bidProject._id}/bid`, {
            //    amount: bidAmount,
            //    proposal: bidProposal,
            //    deliveryDays: bidDays
            //});

            //alert('Bid submitted 🚀');

            const res = await api.post(`/freelancer/${bidProject._id}/bid`, {
                amount: bidAmount,
                proposal: bidProposal,
                deliveryDays: bidDays
            });

            console.log('BID RESPONSE:', res.data);

            setShowBidModal(false);
            setBidAmount('');
            setBidProposal('');
            setBidDays('');

            fetchBids(); // refresh
        } catch (error) {
            alert(error.response?.data?.message || 'Failed to submit bid');
        }
    };

  const getCompetitionColor = (level) => {
    const colors = {
      high: 'text-red-600',
      medium: 'text-yellow-600',
      low: 'text-green-600'
    };
    return colors[level] || 'text-gray-600';
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-6">
        <div className="flex justify-between items-center mb-4">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">Freelancer Projects</h1>
            <p className="text-gray-600 mt-1">Manage and analyze freelancer.com projects</p>
          </div>
          <button
            onClick={() => setShowImportModal(true)}
            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
          >
            + Import Project
          </button>
        </div>

        {/* Filters */}
        <div className="flex gap-4">
          <input
            type="text"
            placeholder="Search projects..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && fetchBids()}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          >
            <option value="">All Status</option>
            <option value="active">Active</option>
            <option value="awarded">Awarded</option>
            <option value="closed">Closed</option>
            <option value="cancelled">Cancelled</option>
          </select>
          <button
            onClick={fetchBids}
            className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
          >
            Search
          </button>
        </div>
      </div>

      {/* Projects Grid */}
      {loading ? (
        <div className="text-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading projects...</p>
        </div>
      ) : bids.length === 0 ? (
        <div className="text-center py-12 bg-gray-50 rounded-lg">
          <p className="text-gray-500">No projects found. Import your first project!</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {bids.map(bid => (
            <div key={bid._id} className="bg-white rounded-lg shadow-md hover:shadow-lg transition p-6">
              {/* Header */}
              <div className="flex justify-between items-start mb-4">
                <span className={`px-3 py-1 rounded-full text-xs font-semibold ${getStatusColor(bid.status)}`}>
                  {bid.status}
                </span>
                <button
                  onClick={() => handleSync(bid._id)}
                  className="text-gray-400 hover:text-blue-600 transition"
                  title="Sync with Freelancer.com"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                  </svg>
                </button>
              </div>

              {/* Title */}
              <h3 className="text-lg font-bold text-gray-800 mb-2 line-clamp-2">
                {bid.projectTitle}
              </h3>

              {/* Stats */}
              <div className="space-y-2 mb-4">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Total Bids:</span>
                  <span className="font-semibold">{bid.totalBids}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Avg Bid:</span>
                  <span className="font-semibold">${bid.averageBid?.toFixed(2)}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Budget:</span>
                  <span className="font-semibold">
                    ${bid.budget?.min} - ${bid.budget?.max}
                  </span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Competition:</span>
                  <span className={`font-semibold ${getCompetitionColor(bid.analytics?.competitionLevel)}`}>
                    {bid.analytics?.competitionLevel || 'N/A'}
                  </span>
                </div>
              </div>

              {/* Skills */}
              <div className="flex flex-wrap gap-2 mb-4">
                {bid.skills?.slice(0, 3).map((skill, idx) => (
                  <span key={idx} className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded">
                    {skill}
                  </span>
                ))}
                {bid.skills?.length > 3 && (
                  <span className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded">
                    +{bid.skills.length - 3}
                  </span>
                )}
              </div>

              {/* Actions */}
              <div className="flex gap-2">
                <button
                  onClick={() => viewDetails(bid)}
                  className="flex-1 bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition text-sm"
                >
                  View Details
                      </button>
                      <button
                          onClick={() => {
                              setBidProject(bid);
                              setShowBidModal(true);
                          }}
                          className="flex-1 bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 transition text-sm"
                      >
                          Place Bid
                      </button>
                      {/* 🚀 REAL Freelancer Button */}
                      <a
                          href={`https://www.freelancer.com/projects/${bid.projectId}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex-1 text-center bg-purple-600 text-white py-2 px-4 rounded-lg hover:bg-purple-700 transition text-sm"
                      >
                          Bid on Freelancer 🚀
                      </a>
                <button
                  onClick={() => handleUpdateStatus(bid._id, bid.status === 'active' ? 'closed' : 'active')}
                  className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition text-sm"
                >
                  {bid.status === 'active' ? 'Close' : 'Reopen'}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Import Modal */}
      {showImportModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-8 max-w-md w-full">
            <h2 className="text-2xl font-bold mb-4">Import Project</h2>
            <p className="text-gray-600 mb-6">
              Enter the Freelancer.com project ID to import
            </p>
            <form onSubmit={handleImport}>
              <input
                type="text"
                placeholder="Project ID (e.g., 12345678)"
                value={projectId}
                onChange={(e) => setProjectId(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg mb-4 focus:ring-2 focus:ring-blue-500"
                required
              />
              <div className="flex gap-4">
                <button
                  type="button"
                  onClick={() => {
                    setShowImportModal(false);
                    setProjectId('');
                  }}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex-1 bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition"
                >
                  Import
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Details Modal */}
      {showDetailsModal && selectedBid && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg p-8 max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-start mb-6">
              <div>
                <h2 className="text-2xl font-bold mb-2">{selectedBid.projectTitle}</h2>
                <span className={`px-3 py-1 rounded-full text-xs font-semibold ${getStatusColor(selectedBid.status)}`}>
                  {selectedBid.status}
                </span>
              </div>
              <button
                onClick={() => setShowDetailsModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Description */}
            <div className="mb-6">
              <h3 className="font-semibold text-gray-800 mb-2">Description</h3>
              <p className="text-gray-600">{selectedBid.projectDescription}</p>
            </div>

            {/* Analytics */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
              <div className="bg-blue-50 p-4 rounded-lg">
                <p className="text-sm text-gray-600">Total Bids</p>
                <p className="text-2xl font-bold text-blue-600">{selectedBid.totalBids}</p>
              </div>
              <div className="bg-green-50 p-4 rounded-lg">
                <p className="text-sm text-gray-600">Avg Bid</p>
                <p className="text-2xl font-bold text-green-600">${selectedBid.averageBid?.toFixed(2)}</p>
              </div>
              <div className="bg-yellow-50 p-4 rounded-lg">
                <p className="text-sm text-gray-600">Lowest Bid</p>
                <p className="text-2xl font-bold text-yellow-600">${selectedBid.lowestBid}</p>
              </div>
              <div className="bg-purple-50 p-4 rounded-lg">
                <p className="text-sm text-gray-600">Recommended</p>
                <p className="text-2xl font-bold text-purple-600">${selectedBid.analytics?.recommendedBid}</p>
              </div>
            </div>

            {/* Bids List */}
            <div>
              <h3 className="font-semibold text-gray-800 mb-4">Bids ({selectedBid.bids?.length})</h3>
              <div className="space-y-3 max-h-64 overflow-y-auto">
                {selectedBid.bids?.map((bid, idx) => (
                  <div key={idx} className="border border-gray-200 rounded-lg p-4">
                    <div className="flex justify-between items-start mb-2">
                      <div>
                        <p className="font-semibold">{bid.bidderUsername}</p>
                        <p className="text-sm text-gray-600">
                          ⭐ {bid.bidderRating?.toFixed(1)} ({bid.bidderReviews} reviews)
                        </p>
                      </div>
                      <div className="text-right">
                        <p className="text-lg font-bold text-green-600">${bid.amount}</p>
                        <p className="text-sm text-gray-600">{bid.deliveryTime} days</p>
                      </div>
                    </div>
                    <p className="text-sm text-gray-600">{bid.description}</p>
                  </div>
                ))}
              </div>
                      </div>


          </div>
        </div>
          )}

          {showBidModal && bidProject && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="bg-white rounded-lg p-6 w-full max-w-md">
                      <h2 className="text-xl font-bold mb-4">Place Your Bid</h2>

                      <input
                          type="number"
                          placeholder="Amount ($)"
                          value={bidAmount}
                          onChange={(e) => setBidAmount(e.target.value)}
                          className="w-full mb-3 px-3 py-2 border rounded"
                      />

                      <input
                          type="number"
                          placeholder="Delivery Days"
                          value={bidDays}
                          onChange={(e) => setBidDays(e.target.value)}
                          className="w-full mb-3 px-3 py-2 border rounded"
                      />

                      <textarea
                          placeholder="Proposal"
                          value={bidProposal}
                          onChange={(e) => setBidProposal(e.target.value)}
                          className="w-full mb-3 px-3 py-2 border rounded"
                      />

                      <div className="flex gap-2">
                          <button
                              onClick={() => setShowBidModal(false)}
                              className="flex-1 border px-4 py-2 rounded"
                          >
                              Cancel
                          </button>

                          <button
                              onClick={handlePlaceBid}
                              className="flex-1 bg-green-600 text-white px-4 py-2 rounded"
                          >
                              Submit
                          </button>
                      </div>
                  </div>
              </div>
          )}
    </div>
  );
};

export default FreelancerBids;
